// extracted by mini-css-extract-plugin
export default {"arrows":"ResizeIcon_arrows__krZVm","path":"ResizeIcon_path__TPd9l"};